// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"30065":"589d8a59a4be3154","44520":"e3ca36435cb7915e","55395":"d63f83bbc2c608fc"}[chunkId] + ".css";
};